import cookies from 'js-cookie';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

import { usePopup } from '@collab/features/popup';

const ProtectedContentModal = dynamic(
  () => import('./impl/ProtectedContentModal'),
);

const AKAMAI_COOKIE_KEY = 'adsso_ak_token';

const useAkamaiAuth = () => {
  const { openPopup, closePopup } = usePopup();
  const [hasToken, setHasToken] = useState(true);

  useEffect(() => {
    setHasToken(!!cookies.get(AKAMAI_COOKIE_KEY));
  }, []);

  const guard = (href: string) => {
    openPopup({
      title: 'Please sign in',
      components: (
        <ProtectedContentModal redirectPath={href} onClose={closePopup} />
      ),
    });
  };

  return {
    guard,
    isVerified: hasToken,
  };
};

export default useAkamaiAuth;
